// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { CredentialGeneratedBySchema } from '../inputTypeSchemas/CredentialGeneratedBySchema'
import { AuthenticationScriptStatusSchema } from '../inputTypeSchemas/AuthenticationScriptStatusSchema'
import { CredentialDisableReasonSchema } from '../inputTypeSchemas/CredentialDisableReasonSchema'

/////////////////////////////////////////
// APPLICATION CREDENTIAL SCHEMA
/////////////////////////////////////////

export const ApplicationCredentialSchema = z.object({
  generatedBy: CredentialGeneratedBySchema,
  authenticationScriptStatus: AuthenticationScriptStatusSchema,
  disableReason: CredentialDisableReasonSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  name: z.string().nullable(),
  ssoProvider: z.string(),
  role: z.string(),
  roleId: z.string().nullable(),
  roleDescription: z.string().nullable(),
  loginUrl: z.string().nullable(),
  username: z.string(),
  password: z.string().nullable(),
  tenant: z.string().nullable(),
  authProbe: JsonValueSchema.nullable(),
  enrollmentExtras: JsonValueSchema.nullable(),
  generatedMailboxAddress: z.string().nullable(),
  authenticationScript: z.string().nullable(),
  isDisabled: z.boolean(),
  disabledAt: z.coerce.date().nullable(),
  disabledBy: z.string().nullable(),
  katanaDispatchedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().nullable(),
})

export type ApplicationCredential = z.infer<typeof ApplicationCredentialSchema>

export default ApplicationCredentialSchema;
